/**
 * Created by Mark on 05/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

export default class BarGraph extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state = {
            id: this.props.id || Math.random(),
            dataKeys:  props.dataKeys || [] ,
            height:this.props.height || 100,
            data:props.data || []
        }

        this.updateDimensions = this.updateDimensions.bind(this);
    }

    updateDimensions(){

        this.setState({
            width:document.getElementById(this.state.id).clientWidth,
        })
    }

    componentWillReceiveProps(props){
        this.setState({data:props.data})
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize"   , this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    renderBars(){

        var lines = [];
        for(var idx = 0 ; idx < this.state.dataKeys.length; idx++)
        {
            lines.push(<Bar key={"bar-"+idx} type="monotone" dataKey={this.state.dataKeys[idx].key} fill={this.state.dataKeys[idx].fill} activeDot={{r: 8}}/>);
        }

        return lines;
    }

    render(){

        const xAxis = this.props.hasX ? <XAxis dataKey="name"/> : null;
        return(
            <div id={this.state.id}>
                <BarChart width={this.state.width} height={this.state.height} data={this.state.data}>
                    {xAxis}
                    <Tooltip/>
                    {this.renderBars()}
                </BarChart>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/graphs/base/BarGraph.js